import { Modal } from "antd";
import Notiflix from "notiflix";
import { useContext, useEffect, useState } from "react";
import {
  Container,
  Dropdown,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { AiFillInstagram } from "react-icons/ai";
import { BiSolidUser } from "react-icons/bi";
import {
  FaAngleDown,
  FaFacebookF,
  FaLinkedinIn,
  FaPinterestP,
  FaUser,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { HiMiniBars3CenterLeft } from "react-icons/hi2";
import { IoMdMail } from "react-icons/io";
import { IoCall, IoClose, IoSearch } from "react-icons/io5";
import { MdLocationPin, MdShoppingCart } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
// import logo from "../../assets/img/floral-hut-logo.png";
import { store } from "../../Helper/Context/Store";
import PostApiCall from "../../Helper/PostApi";
import HomeLocation from "../LocationAndAddress/HomeLocation";
import ChangePassword from "../Login/ChangePassword";
import LoginModal from "../Login/LoginModal";
import LogoutModal from "../Login/LogoutModal";
import SocialIcons from "../WrappperComponent/SocialIcons";
import "./MainNavabar.css";
import GetApiCall from "../../Helper/GetApi";
import MainNavabarMenu from "./MainNavabarMenu";
import { FacebookIcon } from "react-share";
const categories = [
  {
    title: "Flowers",
    subItems: [
      {
        title: "Types of Flowers",
        items: [
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
        ],
      },
      {
        title: "Occasions",
        items: [
          { name: "Birthday" },
          { name: "Anniversary" },
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
        ],
      },
      {
        title: "Types of Flowers",
        items: [
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
        ],
      },
      {
        title: "Occasions",
        items: [
          { name: "Birthday" },
          { name: "Anniversary" },
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
        ],
      },
      {
        title: "Types of Flowers",
        items: [
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
          { name: "Roses" },
          { name: "Lilies" },
          { name: "Orchids" },
          { name: "Sunflower" },
          { name: "Orchids" },
        ],
      },
    ],
  },
  {
    title: "Cakes",
    subItems: [
      {
        title: "Flavors",
        items: [{ name: "Chocolate" }, { name: "Black Forest" }],
      },
    ],
  },
];

export default function MainNavabar({ }) {
  const history = useHistory();
  // const [loggedIn, setLoggedIn] = useState("");
  const {
    cart,
    setcart,
    setcartamount,
    clientData,
    siteHeader,
    mapAddress,
    setHomeLocationModal,
    loggedIn,
    setLoggedIn,
    setCartItems,
    logo,
    selectedPincode,
    setShowSearchBar,
    showSearchBar
  } = useContext(store);
  const [suggestionPro, setSuggestionPro] = useState([]);
  const [seachBar, setseachBar] = useState(false);
  const [loginModalStatus, setLoginModalStatus] = useState(false);
  const [modalSide, setModalSide] = useState("");
  const [canLogout, setCanLogout] = useState(false);
  const [openChangePwd, setOpenChangePwd] = useState(false);
  const [seachData, setSeachData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [Offcanvas1, setOffcanvas1] = useState(false);
  const [open, setOpen] = useState(false);
  const handleCloseoffcanvas = () => setOffcanvas1(false);
  const handleShowoffcanvas = () => setOffcanvas1(true);
  const getCustomerDetails = () => {
    var loginDetails = JSON.parse(localStorage.getItem("CustomerData"));
    if (loginDetails !== null) {
      setLoggedIn(true);
    }
  };
  const clearItemDetails = () => {
    localStorage.removeItem("itemdetails");
  };
  const handleProfileClick = () => {
    history.push("/customer-profile");
  };
  const changePssword = () => {
    setOpenChangePwd(true);
  };
  const handleToggleModal = () => {
    setLoginModalStatus(false);
  };
  const handleChangeModalSide = (e) => {
    setModalSide(e);
  };
  // change password specific functions
  const handleTogglePwdModal = () => {
    setOpenChangePwd(false);
  };
  const handleToggleLogout = () => {
    setCanLogout(false);
  };
  const onLogout = () => {
    if (localStorage.getItem("CustomerData") !== null) {
      localStorage.removeItem("CustomerData");
      localStorage.removeItem("OrderData");
      setcart(0);
      setcartamount(0);
      setCartItems([]);
      history.push("/");
      setLoggedIn(false);
      setCanLogout(false);
      Notiflix.Loading.remove();
    } else {
      Notiflix.Notify.failure("Something went wrong");
    }
  };
  useEffect(() => {
    getCustomerDetails();
    SearchVariantByProduct();
    getSuggestionProducts();
    // eslint-disable-next-line
  }, []);
  const getSuggestionProducts = () => {
    GetApiCall.getRequest("GetHomepageSetup").then((resultdes) =>
      resultdes.json().then((obj) => {
        // setHomePageSetup(obj.data);
        obj.data
          .filter((value) => value.fld_section_name === "Featured Products")
          .forEach((filtereddata) => {
            PostApiCall.postRequest(
              {
                sectionname: filtereddata.fld_section_name,
                itemchoice: filtereddata.fld_item_choice,
              },
              "GetWebsiteHomePageItems"
            ).then((results) => {
              if (results.status === 200 || results.status === 201) {
                results.json().then((data) => {
                  // setHeading1(filtereddata.fld_headline1)
                  // setHeading2(filtereddata.fld_headline2)
                  setSuggestionPro(data.data);
                });
              }
            });
          });
      })
    );
  };
  const SearchVariantByProduct = () => {
    Notiflix.Loading.circle();
    PostApiCall.postRequest(
      {
        variantName: "",
      },
      "SearchVariantByProduct"
    )
      .then((res) => res.json())
      .then((res1) => {
        if (res1.data) {
          setSeachData(res1.data);
          Notiflix.Loading.remove();
        }
      });
  };
  const handleToggleDetect = (detectedPincode) => {
    if (detectedPincode === selectedPincode) {
      setOpen(false);
      return;
    } else if (detectedPincode === undefined) {
      setOpen(false);
    } else {
      Notiflix.Notify.failure("Delivery not available in this area");
    }
  };
  useEffect(() => {
    if (showSearchBar) {
      document.body.classList.add('searchbar-active');
    } else {
      document.body.classList.remove('searchbar-active');
    }
  }, [showSearchBar]);
  return (
    <>
      <LoginModal
        isOpen={loginModalStatus}
        handleToggleModal={handleToggleModal}
        modalSide={modalSide}
        handleChangeModalSide={handleChangeModalSide}
      />

      <ChangePassword
        isOpen={openChangePwd}
        handdleToggleModal={handleTogglePwdModal}
      />
      <LogoutModal
        show={canLogout}
        onHide={handleToggleLogout}
        onLogout={onLogout}
      />
      <Navbar expand="lg" className="main-navbar py-0 position-relative">
        <Container fluid>
          <div className="d-flex align-items-center mobile-logo">
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand-lg d-lg-none"
              onClick={handleShowoffcanvas}>
              <HiMiniBars3CenterLeft />
            </Navbar.Toggle>
            <Navbar.Brand className="d-flex align-items-center">
              <Link to="/">
                <img alt="" src={logo} className="img-fluid nav-logo" />
              </Link>
            </Navbar.Brand>
          </div>
          <div className="d-none d-lg-block">
            <MainNavabarMenu />
          </div>
          <Navbar.Offcanvas
            show={Offcanvas1}
            onHide={handleCloseoffcanvas}
            className="d-lg-none main-navbar-offcanvas"
            id="offcanvasNavbar-expand-lg"
            aria-labelledby="offcanvasNavbarLabel-expand-lg"
            placement="start">
            <Offcanvas.Header closeButton>
              <Link to="/" onClick={handleCloseoffcanvas}>
                <img alt="" src={logo} className="img-fluid nav-logo" />
              </Link>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0">
              <Nav className="justify-content-end flex-grow-1 pe-3">
                {/* <Link to="/our-story" className="nav-link" onClick={handleCloseoffcanvas}>
                  Our Story
                </Link> */}

                {/* {siteHeader?.length > 0
                  ? siteHeader?.map((data, index) => {
                    return (
                      <li key={`main-header${index}`}>
                        <NavDropdown
                          title={data.label}
                          id={data.id}
                          renderMenuOnMount={true}>
                          {data.subcategories?.map((subcat, ind) => {
                            return (
                              <NavDropdown.Item
                                onClick={handleCloseoffcanvas}
                                key={`subcat-${ind}`}
                                as={Link} // Use Link as the 'as' prop
                                to={`/${subcat.path1}`}
                                className="w-100">
                                {subcat.label1}
                              </NavDropdown.Item>
                            );
                          })}
                        </NavDropdown>
                      </li>
                    );
                  })
                  : ""} */}
                <div className="mobile-dropdown-container">
                  {siteHeader?.map((category, index) => (
                    <NavDropdown
                      key={index}
                      title={category?.label}
                      className="w-100">
                      {category?.subcategories?.filter((submenu) => submenu?.fld_showOnWebsite === "InActive")?.map((submenu, subIndex) => (
                        <NavDropdown
                          key={subIndex}
                          title={submenu.label1}
                          className="w-100 submenu-link">
                          {submenu?.subcat?.map((item, idx) => (
                            <NavDropdown.Item
                              key={idx}
                              href={item?.path}
                              className="d-flex align-items-center">
                              {item.label1}
                            </NavDropdown.Item>
                          ))}
                        </NavDropdown>
                      ))}
                    </NavDropdown>
                  ))}
                </div>

                {/* <Link to="/" className="nav-link" onClick={handleCloseoffcanvas}>
                  Gifting Ideas
                </Link>

                <Link to="/" className="nav-link" onClick={handleCloseoffcanvas}>
                  Festive Collection
                </Link> */}
                <Link
                  to="/contact-us"
                  className="nav-link"
                  onClick={handleCloseoffcanvas}>
                  Contact Us
                </Link>
              </Nav>
              <div className="d-flex contact-links justify-content-start my-2">
                <IoCall />
                <a href={`tel:${clientData[0]?.mobile}`}>
                  {clientData[0]?.mobile}
                </a>
              </div>
              <div className="d-flex contact-links justify-content-start mb-3">
                <IoMdMail />
                <a href={`mailto:${clientData[0]?.email}`}>
                  {clientData[0]?.email}
                </a>
              </div>
              <h6>Show us your love & follow</h6>
              <ul className="d-flex contact-links sm-contact-links my-2 ps-0 justify-content-start">
                <SocialIcons
                  link={clientData[0]?.facebook}
                  target="_blank"
                  logo={<FaFacebookF />}
                  name={"Facebook"}
                />
                <SocialIcons
                  link={clientData[0]?.instagram}
                  target="_blank"
                  logo={<AiFillInstagram />}
                  name={"Instagram"}
                />
                <SocialIcons
                  link={clientData[0]?.twitter}
                  target="_blank"
                  logo={<FaXTwitter />}
                  name={"X"}
                />
                <SocialIcons
                  link={clientData[0]?.linkedin}
                  target="_blank"
                  logo={<FaLinkedinIn />}
                  name={"LinkedinIn"}
                />
                <SocialIcons
                  link={clientData[0]?.pintrest}
                  target="_blank"
                  logo={<FaPinterestP />}
                  name={"Pinterest"}
                />
                <SocialIcons
                  link={clientData[0]?.youtube}
                  target="_blank"
                  logo={<FaYoutube />}
                  name={"Youtube"}
                />
              </ul>
              {/* <div className="d-flex contact-links my-2">
                <IoCall />
                <a href={`tel:${clientData[0]?.mobile}`}>
                  {clientData[0]?.mobile}
                </a>
              </div>
              <div className="d-flex contact-links mb-2">
                <IoMdMail />
                <a href={`mailto:${clientData[0]?.email}`}>
                  {clientData[0]?.email}
                </a>
              </div>
              <p className="mb-0 fw-bold mt-3">Follow us on</p>
              <ul className="contact-links d-flex mt-2">
                <SocialIcons
                  link={clientData[0]?.facebook}
                  target="_blank"
                  logo={<FaFacebookF />}
                />
                <SocialIcons
                  link={clientData[0]?.instagram}
                  target="_blank"
                  logo={<AiFillInstagram />}
                />
                <SocialIcons
                  link={clientData[0]?.twitter}
                  target="_blank"
                  logo={<FaXTwitter />}
                />
                <SocialIcons
                  link={clientData[0]?.linkedin}
                  target="_blank"
                  logo={<FaLinkedinIn />}
                />
                <SocialIcons
                  link={clientData[0]?.pintrest}
                  target="_blank"
                  logo={<FaPinterestP />}
                />
                <SocialIcons
                  link={clientData[0]?.youtube}
                  target="_blank"
                  logo={<FaYoutube />}
                />
              </ul> */}
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <ul className="main-nav-right-links contact-links d-none d-lg-flex">
            <li>
              {/* <div
                onClick={() => {
                  setOpen(true);
                  setHomeLocationModal(true);
                }}
                className="nav-location-box d-flex align-items-center"
              >
                <MdLocationPin className="me-lg-1 mb-1" />
                <p>
                  {mapAddress
                    ? mapAddress
                    : sessionStorage.getItem("Form_Add")
                      ? JSON.parse(sessionStorage.getItem("Form_Add"))
                      : "Select Location"}
                </p>
                <FaAngleDown />
              </div> */}
            </li>
            <li className="me-2">
              <IoSearch
                className="cursor-pointer"
                onClick={
                  () => setShowSearchBar(true)
                  // () => setseachBar(true)
                }
              />
            </li>
            <li>
              <Dropdown className="login-dropdown d-none d-lg-flex">
                <Dropdown.Toggle
                  // onClick={onProfileClick}
                  className="login-icon"
                  id="dropdown-basic">
                  <FaUser />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {loggedIn === false && (
                    <>
                      <Dropdown.Item
                        onClick={() => {
                          setModalSide("Log");
                          setLoginModalStatus(true);
                          clearItemDetails();
                        }}>
                        Login
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setModalSide("Reg");
                          setLoginModalStatus(true);
                          clearItemDetails();
                        }}>
                        Sign Up
                      </Dropdown.Item>
                    </>
                  )}
                  {loggedIn === true && (
                    <>
                      <Dropdown.Item onClick={handleProfileClick}>
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item onClick={changePssword}>
                        Change Password
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setCanLogout(true)}>
                        Logout
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="login-dropdown d-flex d-lg-none">
                <Dropdown.Toggle
                  // onClick={onProfileClick}
                  className="login-icon"
                  id="dropdown-basic">
                  <BiSolidUser />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {loggedIn === false && (
                    <>
                      <Dropdown.Item
                        onClick={() => {
                          setModalSide("Log");
                          setLoginModalStatus(true);
                          clearItemDetails();
                        }}>
                        Login
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setModalSide("Reg");
                          setLoginModalStatus(true);
                          clearItemDetails();
                        }}>
                        {" "}
                        Sign Up
                      </Dropdown.Item>
                    </>
                  )}
                  {loggedIn === true && (
                    <>
                      <Dropdown.Item onClick={handleProfileClick}>
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item onClick={changePssword}>
                        Change Password
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setCanLogout(true)}>
                        Logout
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </li>
            <Link to="/cart">
              <li className="cursor-pointer me-md-2">
                <MdShoppingCart />
                <span>{cart} Items</span>
              </li>
            </Link>

            {/* <li>
              <a href="">
                <FaFacebookF />
              </a>
            </li>
            <li>
              <a href="">
                <AiFillInstagram />
              </a>
            </li>
            <li>
              <a href="">
                <FaXTwitter />
              </a>
            </li>
            <li>
              <a href="">
                <FaLinkedinIn />
              </a>
            </li>
            <li>
              <a href="">
                <FaPinterestP />
              </a>
            </li>
            <li>
              <a href="">
                <FaYoutube />
              </a>
            </li> */}
          </ul>

          <div
            className={
              seachBar === true
                ? "searchbar-main-active searchbar-main"
                : "searchbar-main"
            }>
            <div className="searchbar-input">
              <div className="box">
                <IoSearch />
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    // setseachResult(true);
                  }}
                  placeholder="Search"
                />
                <IoClose
                  onClick={() => {
                    setSearchText("");
                    setseachBar(false);
                  }}
                />
              </div>
            </div>
            <div
              className={
                searchText === "" ? "results row" : "results-active results row"
              }>
              <div className="col-lg-4 d-none d-lg-block">
                <h5 className="border-bottom pb-2">Suggestions</h5>
                {suggestionPro.length > 0 &&
                  suggestionPro.map((data, index) => {
                    return (
                      <div key={index} className="mb-4 cusror-pointer">
                        <Link
                          onClick={() => {
                            setseachBar(false);
                            setSearchText("");
                          }}
                          to={`/p/${data.fld_route}`}
                        // to={`/productdetail/${data.fld_variantname?.replace(
                        //   /\s/g,
                        //   "-"
                        // )}-${data.fld_variantname?.replace(/\s/g, "-")}/${data.fld_variantid
                        //   }`}
                        >
                          <div className="produst-card">
                            <div className="img">
                              <img
                                alt={data.fld_variantname}
                                src={data.VariantImage}
                                className="img-fluid"
                              />
                            </div>
                            <div className="content">
                              <p>{data.fld_variantname}</p>
                              <div className="price">
                                &#x20B9; {data.fld_selling_price}{" "}
                                {data.fld_mrp > data.fld_selling_price && (
                                  <del>&#x20B9; {data.fld_mrp}</del>
                                )}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
              <div className="col-lg-8">
                <h5 className="border-bottom pb-2">Products</h5>
                <div className="row">
                  {seachData
                    ?.filter((dat) =>
                      dat.SearchData.toLowerCase().includes(
                        searchText.toLowerCase()
                      )
                    )
                    .map((data, index) => {
                      return (
                        <div
                          key={index}
                          className="col-lg-6 mb-4 cusror-pointer">
                          <Link
                            onClick={() => {
                              setseachBar(false);
                              setSearchText("");
                            }}
                            to={`/p/${data.fld_route}`}
                          // to={`${process.env.PUBLIC_URL
                          //   }/p/${data.fld_route?.replace(
                          //     /\s/g,
                          //     "-"
                          //   ).replace('/', '')}`}
                          >
                            <div className="produst-card">
                              <div className="img">
                                <img
                                  alt={data.fld_variantname}
                                  src={data.fld_imageurl}
                                  className="img-fluid"
                                />
                              </div>
                              <div className="content">
                                <p>{data.fld_variantname}</p>
                                <div className="price">
                                  &#x20B9; {data.fld_selling_price}{" "}
                                  {data.fld_mrp > data.fld_selling_price && (
                                    <del>&#x20B9; {data.fld_mrp}</del>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div
              className="serach-close"
              onClick={() => {
                setseachBar(false);
                setSearchText("");
              }}></div>
          </div>
          <Modal
            title={<p>Delivery Location</p>}
            open={open}
            centered
            footer={false}
            onCancel={() => {
              setOpen(false);
              setHomeLocationModal(false);
            }}>
            <HomeLocation handleToggleDetect={handleToggleDetect} />
            {JSON.parse(localStorage.getItem("CustomerData")) && (
              <div
                className="cursor-pointer theme-btn mx-auto"
                onClick={() => {
                  setOpen(false);
                  setHomeLocationModal(false);
                  history.push("/customer-profile");
                }}>
                <p className="mb-0">View All Address</p>
              </div>
            )}
          </Modal>
        </Container>
      </Navbar>
    </>
  );
}
